<template>
	<div class="login-container">
		<div class="bg-gradient"></div>
		<div class="login-card">
			<div class="brand-area">
				<div class="logo-circle">
					<span class="logo-text">有</span>
				</div>
				<span class="app-name">有享花</span>
			</div>
			<div class="form-box">
				<div class="input-group with-icon">
					<span class="input-icon">📱</span>
					<input 
						v-model="formData.phoneNumber"
						type="number"
						placeholder="请输入手机号"
						class="placeholder-style"
						maxlength="11"
						@focus="inputFocused = true"
						@blur="inputFocused = false"
						:class="{ focused: inputFocused }"
					/>
				</div>
				<div class="agreement">
					<label @click="toggleAgreement">
						<div :class="['checkbox', { checked: formData.agreed }]">
							<span v-if="formData.agreed" class="checkmark">✓</span>
						</div>
						<span>我已阅读并同意</span>
					</label>
					<span class="policy-link" @click="navigateToPolicy">《隐私政策》</span>
				</div>
				<button 
					:class="['login-btn', { active: canLogin, loading: isLoading }]" 
					:disabled="!canLogin || isLoading"
					@click="handleLogin"
				>
					<span v-if="!isLoading">登录</span>
					<div v-else class="loading-spinner"></div>
				</button>
			</div>
		</div>
		<div class="wave-bg"></div>
		<div class="wave-bg"></div>
	</div>
</template>

<script>
import { validatePhone, sanitizeInput, safeLog } from '@/utils/security'
import { debounce } from '@/utils/performance'
import { getStorage, removeStorage } from '@/utils/storage'

export default {
	data() {
		return {
			formData: {
				phoneNumber: '',
				agreed: true
			},
			inputFocused: false,
			isLoading: false
		}
	},
	
	computed: {
		canLogin() {
			return validatePhone(this.formData.phoneNumber) && this.formData.agreed
		}
	},
	
	created() {
		try {
			this.userInfo = getStorage('userInfos')
		} catch (error) {
			safeLog('Login page created error:', error)
		}
	},
	
	mounted() {
		this.onMounted()
	},
	
	methods: {
		toggleAgreement() {
			this.formData.agreed = !this.formData.agreed
		},
		
		navigateToPolicy() {
			this.$router.push('/privacy')
		},
		
		handlePhoneInput: debounce(function(e) {
			const value = e.target?.value || e
			this.formData.phoneNumber = sanitizeInput(value, 11)
		}, 200),
		async handleLogin() {
			safeLog('=== 点击登录按钮 ===')
			if (!this.canLogin || this.isLoading) {
				safeLog('无法登录，canLogin:', this.canLogin, 'isLoading:', this.isLoading)
				return
			}
			
			this.isLoading = true
			
			try {
				safeLog('开始调用 store login action')
				const result = await this.$store.dispatch('user/login', {
					phone: this.formData.phoneNumber,
					datas: []
				})
				
				safeLog('store login 返回结果:', result)
				
				if (result.success) {
					this.$success('登录成功').then(() => {
						safeLog('✅ 登录成功，准备跳转到首页')
						this.$router.push('/index')
					})
				} else {
					this.$error(result.message)
				}
			} catch (error) {
				safeLog('❌ 登录异常:', error)
				this.$error(error.message || '网络异常，请重试')
			} finally {
				this.isLoading = false
			}
		},
		
		async onMounted() {
			safeLog('登录页面 onMounted')
			
			const token = getStorage('token', '');
			safeLog('=== 登录页读取到的token ===', token);
			if (!token) {
				safeLog('未找到token，停留在登录页')
				return;
			}
			
			try {
				safeLog('有token存在，尝试自动登录')
				const result = await this.$store.dispatch('user/autoLogin')
				safeLog('autoLogin 结果:', result)
				
				if (result.success) {
					safeLog('自动登录成功，准备跳转到首页')
					setTimeout(() => {
						this.$router.push('/index')
					}, 500)
				} else {
					safeLog('自动登录失败，token可能已过期，停留在登录页')
					removeStorage('token');
					removeStorage('userInfos');
				}
			} catch (error) {
				safeLog('自动登录异常:', error)
				removeStorage('token');
				removeStorage('userInfos');
			}
		}
	}
}
</script>

<style scoped>
* {
	box-sizing: border-box;
}
.login-container {
	position: relative;
	min-height: 100vh;
	overflow: hidden;
}
.bg-gradient {
	width: 100%;
	height: 210px;
	background: linear-gradient(135deg, #0FB54C 0%, #8DC641 50%, #a8e6cf 100%);
	border-radius: 0 0 70% 70% / 0 0 35% 35%;
	box-shadow: 0 6px 20px rgba(15, 181, 76, 0.2);
}
.login-card {
	background: linear-gradient(145deg, #ffffff 0%, #f8fffb 100%);
	border-radius: 16px;
	width: 80%;
	margin: 33px auto 0;
	padding: 20px 16px;
	box-shadow: 0 10px 30px rgba(0, 0, 0, 0.12);
	z-index: 2;
	transform-origin: top center;
	margin-top: calc(-90px);
	border: 1px solid rgba(255, 255, 255, 0.8);
	backdrop-filter: blur(5px);
}
.brand-area {
	display: flex;
	flex-direction: column;
	align-items: center;
	margin-bottom: 20px;
}
.logo-circle {
	width: 90px;
	height: 90px;
	border-radius: 50%;
	background: linear-gradient(135deg, #0FB54C 0%, #8DC641 100%);
	display: flex;
	align-items: center;
	justify-content: center;
	margin-bottom: 12px;
	box-shadow: 0 6px 16px rgba(15, 181, 76, 0.3);
	animation: logo-pulse 3s ease-in-out infinite;
}
@keyframes logo-pulse {
	0%, 100% { box-shadow: 0 6px 16px rgba(15, 181, 76, 0.3); }
	50% { box-shadow: 0 8px 24px rgba(15, 181, 76, 0.45); }
}
.logo-text {
	color: white;
	font-size: 32px;
	font-weight: 800;
	text-shadow: 0 1px 4px rgba(0, 0, 0, 0.1);
}
.app-name {
	font-size: 26px;
	background: linear-gradient(135deg, #0FB54C 0%, #8DC641 100%);
	-webkit-background-clip: text;
	background-clip: text;
	-webkit-text-fill-color: transparent;
	font-weight: 800;
	letter-spacing: 1.5px;
}
.form-box {
	display: flex;
	flex-direction: column;
	gap: 8px;
}
.input-group.with-icon {
	position: relative;
	margin-bottom: 12px;
}
.input-icon {
	position: absolute;
	left: 12px;
	top: 50%;
	transform: translateY(-50%);
	font-size: 20px;
	z-index: 2;
	filter: drop-shadow(0 1px 2px rgba(0, 0, 0, 0.1));
}
input {
	width: 100%;
	height: 48px;
	padding: 0 44px;
	background: linear-gradient(145deg, #f8f9fa 0%, #ffffff 100%);
	border-radius: 12px;
	font-size: 15px;
	transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
	border: 1px solid #e8f5e9;
	box-sizing: border-box;
	outline: none;
}
input.focused {
	background: linear-gradient(145deg, #e8f5e9 0%, #f1f8f4 100%);
	border-color: #0FB54C;
	box-shadow: 0 0 0 3px rgba(15, 181, 76, 0.08);
}
.placeholder-style::placeholder {
	color: #9ca3af;
}
.agreement {
	display: flex;
	align-items: center;
	margin-bottom: 14px;
	font-size: 11px;
	color: #4b5563;
	padding: 8px 10px;
	background: linear-gradient(145deg, #f8f9fa 0%, #ffffff 100%);
	border-radius: 10px;
	justify-content: flex-start;
	transition: all 0.3s ease;
	border: 1px solid #e8f5e9;
}
.agreement:active {
	background: linear-gradient(145deg, #e8f5e9 0%, #f1f8f4 100%);
	transform: scale(0.98);
}
.checkbox {
	width: 16px;
	height: 16px;
	border: 1px solid #a5d6a7;
	border-radius: 4px;
	margin-right: 8px;
	display: flex;
	align-items: center;
	justify-content: center;
	transition: all 0.3s ease;
	cursor: pointer;
	background: #fff;
}
.checkbox.checked {
	background: linear-gradient(135deg, #0FB54C 0%, #8DC641 100%);
	border-color: #0FB54C;
	transform: scale(1.15);
	box-shadow: 0 2px 6px rgba(15, 181, 76, 0.25);
}
.checkmark {
	color: white;
	font-size: 14px;
	font-weight: bold;
}
.policy-link {
	background: linear-gradient(135deg, #0FB54C 0%, #8DC641 100%);
	-webkit-background-clip: text;
	background-clip: text;
	-webkit-text-fill-color: transparent;
	margin-left: 3px;
	text-decoration: none;
	transition: all 0.3s ease;
	font-weight: 600;
	cursor: pointer;
}
.policy-link:active {
	opacity: 0.8;
}
.agreement label {
	display: flex;
	align-items: center;
	cursor: pointer;
	padding: 5px 8px;
	border-radius: 8px;
	transition: all 0.3s ease;
}
.agreement label:active {
	background-color: rgba(15, 181, 76, 0.06);
}
.login-btn {
	width: 100%;
	height: 54px;
	border-radius: 28px;
	background: linear-gradient(135deg, #c8e6c9 0%, #a5d6a7 100%);
	color: #81c784;
	font-size: 18px;
	font-weight: 700;
	transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
	display: flex;
	justify-content: center;
	align-items: center;
	position: relative;
	overflow: hidden;
	box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
	border: none;
	cursor: pointer;
}
.login-btn.active {
	background: linear-gradient(135deg, #0FB54C 0%, #8DC641 100%);
	color: #ffffff;
	box-shadow: 0 6px 16px rgba(15, 181, 76, 0.4);
	cursor: pointer;
}
.login-btn.active:active {
	transform: translateY(2px) scale(0.98);
	box-shadow: 0 3px 10px rgba(15, 181, 76, 0.45);
}
.loading-spinner {
	width: 22px;
	height: 22px;
	border: 3px solid rgba(255,255,255,0.25);
	border-radius: 50%;
	border-top-color: white;
	animation: spin 0.8s linear infinite;
	box-shadow: 0 0 0 1px rgba(255, 255, 255, 0.1);
}
@keyframes spin {
	0% { transform: rotate(0deg); }
	100% { transform: rotate(360deg); }
}
.wave-bg {
	position: absolute;
	bottom: 0;
	left: 0;
	right: 0;
	height: 60px;
	background-image: url("data:image/svg+xml,%3Csvg xmlns=' http://www.w3.org/2000/svg' viewBox='0 0 1440 320'%3E%3Cpath fill='%230FB54C' fill-opacity='0.08' d='M0,224L48,213.3C96,203,192,181,288,181.3C384,181,480,203,576,208C672,213,768,203,864,181.3C960,160,1056,128,1152,128C1248,128,1344,160,1392,176L1440,192L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z'%3E%3C/path%3E%3C/svg%3E");
	background-size: 720px 60px;
	animation: wave 10s linear infinite;
}
@keyframes wave {
	0% { background-position-x: 0; }
	100% { background-position-x: 720px; }
}
.wave-bg:nth-child(2) {
	opacity: 0.5;
	animation-delay: -5s;
	animation-duration: 15s;
}
</style>
